import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { EmptyNotificationBoardComponent } from "@modules/notifications/features/empty-notification-board/empty-notification-board.component";
import { NotificationsListComponent } from "@modules/notifications/features/notifications-list/notifications-list.component";
import { BpInlineToastModule } from "@modules/shared/bp-inline-toast/bp-inline-toast.module";

@NgModule({
	declarations: [EmptyNotificationBoardComponent, NotificationsListComponent],
	exports: [NotificationsListComponent, EmptyNotificationBoardComponent],
	imports: [CoreModule, BpInlineToastModule]
})
export class NotificationsBoardModule {}
